<template>
  <div v-if="data" id="errors" class="container">
    <div v-if="data.resultCode==='Error'" id="error">

      <SfHeading
          :description="$t('You can contact the support if you want more explanation by mentioning the refusal and the reference of the transaction below')"
          :level="1"
          :title="$t('payment.error')"
          class="heading sf-heading--no-underline color-danger"
      />

      <p><strong>{{ $t('Reason for refusal') }} : {{ $t('payment.error') }} - {{
          $t('adyen.' + codeError)
        }}</strong><br>

        <strong>{{ $t('Transaction reference') }} : {{ data.pspReference }}</strong></p>
      <div class="form-action">
        <SfButton class="sf-button-white sf-button color-secondary" @click="goToContactForm">
          {{ $t('Contact Support') }}
        </SfButton>
        <SfButton class="sf-button-primary sf-button " @click="retryPayment()">
          {{ $t('back to payment') }}
        </SfButton>
      </div>
    </div>
    <div v-else-if="data.resultCode==='Cancelled'" id="cancel">

      <SfHeading
          :description="$t('You can contact the support if you want more explanation by mentioning the refusal and the reference of the transaction below')"
          :level="1"
          :title="$t('payment.cancelled')"
          class="heading sf-heading--no-underline color-danger"
      />

      <p><strong>{{ $t('Reason for refusal') }} : {{ $t('payment.cancelled') }} - {{
          $t('adyen.' + codeError)
        }}</strong><br>
        <strong>{{ $t('Transaction reference') }} : {{ data.pspReference }}</strong></p>

      <div class="form-action">
        <SfButton class="sf-button sf-button-white color-secondary" @click="goToContactForm">
          {{ $t('Contact Support') }}
        </SfButton>
        <SfButton class="sf-button sf-button-primary" @click="retryPayment()">
          {{ $t('back to payment') }}
        </SfButton>
      </div>
    </div>
    <div v-else-if="data.resultCode==='Refused'" id="refused">

      <SfHeading
          :description="$t('You can contact the support if you want more explanation by mentioning the refusal and the reference of the transaction below')"
          :level="1"
          :title="$t('payment.refused')"
          class="heading sf-heading--no-underline color-danger"
      />
      <div class="description">
        <p><strong>{{ $t('Reason for refusal') }} : {{ $t('payment.refused') }} - {{
            $t('adyen.' + codeError)
          }}</strong><br>
          <strong>{{ $t('Transaction reference') }} : {{ data.pspReference }}</strong></p>
      </div>
      <div class="form-action">
        <SfButton class="sf-button color-white text-secondary-color" @click="goToContactForm">
          {{ $t('Contact Support') }}
        </SfButton>
        <SfButton class="sf-button color-primary" @click="retryPayment()">
          {{ $t('back to payment') }}
        </SfButton>

      </div>
    </div>
    <div v-else-if="data.resultCode==='Received'" id="received">

      <SfHeading
          :description="$t('You can contact the support if you want more explanation by mentioning the refusal and the reference of the transaction below')"
          :level="1"
          :title="$t('payment.received')"
          class="heading sf-heading--no-underline color-danger"
      />

      <p><strong>{{ $t('Reason for refusal') }} : {{ $t('payment.received') }} </strong><br>
        <strong>{{ $t('Transaction reference') }} : {{ data.pspReference }}</strong></p>

      <div class="form-action">
        <SfButton class="sf-button-white color-secondary" @click="goToContactForm">
          {{ $t('Contact Support') }}
        </SfButton>
      </div>
    </div>
    <div v-else-if="data.resultCode==='Pending'" id="pending">

      <SfHeading
          :description="$t('You can contact the support if you want more explanation by mentioning the refusal and the reference of the transaction below')"
          :level="1"
          :title="$t('payment.pending')"
          class="heading sf-heading--no-underline color-danger"
      />

      <p><strong>{{ $t('Reason for refusal') }} : {{ $t('payment.pending') }} </strong><br>
        <strong>{{ $t('Transaction reference') }} : {{ data.pspReference }}</strong></p>

      <div class="form-action">
        <SfButton class="sf-button-white color-secondary" @click="goToContactForm">
          {{ $t('Contact Support') }}
        </SfButton>

      </div>
    </div>
    <div v-else-if="data.resultCode==='moneypot'" id="moneypot">

      <SfHeading
          :description="$t('You can contact the support if you want more explanation by mentioning the refusal and the reference of the transaction below')"
          :level="1"
          :title="$t('payment.moneyPot')"
          class="heading sf-heading--no-underline color-danger"
      />

      <p><strong>{{ $t('Reason for refusal') }} : {{ $t('payment.moneyPot') }} - {{
          $t('moneyPot', {balance, shoppingCartPrice})
        }}</strong><br>
        <strong>{{ $t('Transaction reference') }} : {{ data.merchantReference }}</strong></p>

      <div class="form-action">
        <SfButton class="sf-button-white color-secondary" @click="goToContactForm">
          {{ $t('Contact Support') }}
        </SfButton>

      </div>
    </div>
    <div v-else id="unknown">
      <SfHeading
          :description="$t('You can contact the support if you want more explanation by mentioning the refusal and the reference of the transaction below')"
          :level="1"
          :title="$t('payment.unknown')"
          class="heading sf-heading--no-underline color-danger"
      />
      <p><strong>{{ $t('Reason for refusal') }} : {{ $t('adyen.' + codeError) }}</strong><br>
      <p><strong>{{ $t('Transaction reference') }} : {{ data.pspReference }}</strong></p>

      <div class="form-action">
        <SfButton class="sf-button-white color-secondary" @click="goToContactForm">
          {{ $t('Contact Support') }}
        </SfButton>
        <SfButton :link="retryPayment" class="sf-button-primary">
          {{ $t('back to payment') }}
        </SfButton>
      </div>
    </div>
    <!-- TODO: @cyril gérer les cas suivants avec des messages explicatifs dédiés pour chaque cas :

        * Pending	Inform the shopper that you've received their order, and are waiting for the payment to be completed.
                    You will receive the final result of the payment in an AUTHORISATION notification.
        * Refused	Inform the shopper that the payment was refused. Ask the shopper to try the payment again using a different payment method or card.
        * Received  For some payment methods, it can take some time before the final status of the payment is known.
        * Error	    Inform the shopper that there was an error processing their payment.
                    You'll receive a refusalReason in the same response, indicating the cause of the error.
        * NoResult  C'est un truc que j'ai mis côté Orinoko pour dire qu'il n'y a pas eu de code trouvé dans
                    la réponse Adyen. C'est plus pour le backend, ici pour le front, tu dois considérer que c'est "Error"

        Tu dois recevoir les variables resultCode="Pending|Refused|Received|Error"
                                       refusalReason="<texte>"
                                       pspReference="<texte>"

        refusalReason est certainement en anglais mais au pire tu peux marquer en dessous vous pouvez contacter le
        support si vous voulez plus d'explication en mentionnant le refus ci-dessus ET LA REFERENCE CI-DESSUS
        c'est important la pspReference c'est un code pour identifier la requête de façon unique pour qu'Adyen
        jette un oeil en cas de souci. Ce n'est pas grave de la divulguer, c'est pas un élément de sécu.
    -->
  </div>
</template>

<script>

import {SfHeading, SfButton} from '@storefront-ui/vue';
import GtagEvent from "@/utils/GtagEvent";
import Api from "@/api/Api";

export default {
  name: 'PaymentResult',
  components: {SfHeading, SfButton},
  data() {
    return {
      codeError: "",
      data: null,
      balance: null,
      shoppingCartPrice: null,
      orderUuid: null
    }
  },

  mounted() {
    const {query} = this.$route;
    if (!query.data) {
      // TODO: @cyril idéalement il faudrait l'afficher dans la UI mais c'est un cas
      //              qui n'est pas censé arriver donc bon ... ne pas y passer 3h
      this.data = {resultCode: 'Error'};
      // this.$router.push(this.$localizePath("/"))
    } else {
      try {
        this.data = JSON.parse(atob(query.data));

        this.orderUuid = this.data.merchantReference ? this.data.merchantReference : null;

        if (this.data && (this.data.resultCode.toLowerCase() === 'pending' || this.data.resultCode.toLowerCase() === 'received')) {
          if (this.orderUuid) {
            Api.order.getByCartUuid(this.orderUuid).then((order) => {
              this.orderNumber = order.reference
              GtagEvent.purchase(order)
            })
          }
        }
        if (this.data && this.data.resultCode.toLowerCase() === 'moneypot') {
          this.balance = this.data.errorInfo.moneyPotBalance;
          this.shoppingCartPrice = this.data.errorInfo.shoppingCartPrice
        }
      } catch (e) {
        console.log(e)
        this.data = {resultCode: 'Error'};
      }

    }
    this.codeError = "errorCode" + this.data.refusalReasonCode;
  },
  methods: {
    goToContactForm() {
      this.$router.push(this.$localizePath('/contact'))
    },
    retryPayment() {
      this.$router.push(this.$localizePath('/commande/paiement/attente/') + this.orderUuid)
    }
  }

};
</script>

<style lang="scss" scoped>
#errors {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: var(--spacer-2xl) auto;
  max-width: calc(var(--layout-max-width) / 2);

  .description {
    margin: var(--spacer-base) 0;
  }

  .form-action {
    display: flex;
    flex-wrap: wrap;
    margin: var(--spacer-xl) 0 var(--spacer-2xl);

    .sf-button {
      flex: 1;
    }
  }

}
</style>
